module.exports = __webpack_public_path__ + "img/electrician_thumbnail.6f8d98b7.jpg";